document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('register__form');
    const firstNameInput = document.getElementById('RegisterForm-FirstName');
    const lastNameInput = document.getElementById('RegisterForm-LastName');
    const emailInput = document.getElementById('RegisterForm-email');
    const passwordInput = document.getElementById('RegisterForm-password');
    const createAccountBtn = document.getElementById('create-account-submit');
  
    [firstNameInput, lastNameInput, emailInput, passwordInput].forEach(input => {
      // Add event listener to each input
      if (input) {
        input.addEventListener('input', function() {
          clearErrorMessage(input);
        });
      }
    });
    // Add event listener to form
    if (form) {
      form.addEventListener('submit', function(event) {
        let isValid = true;
    
        clearErrorMessages();
    
        if (firstNameInput.value.trim() === '') {
          showError(firstNameInput, 'Please enter your first name.');
          isValid = false;
        }
    
        if (lastNameInput.value.trim() === '') {
          showError(lastNameInput, 'Please enter your last name.');
          isValid = false;
        }
    
        if (emailInput.value.trim() === '') {
          showError(emailInput, 'Please enter your email.');
          isValid = false;
        } else if (!validateEmail(emailInput.value)) {
          showError(emailInput, 'Please enter a valid email address.');
          isValid = false;
        }
    
        if (passwordInput.value.trim() === '') {
          showError(passwordInput, 'Password cannot be empty');
          isValid = false;
        } else if (passwordInput.value.length < 8) {
          showError(passwordInput, 'Password must be at least 8 characters long');
          isValid = false;
        }
    
        if (!isValid) {
          event.preventDefault(); 
          createAccountBtn.focus(); 
        }
      });
    }
  
    function showError(input, message) {
        let errorSpan = input.parentNode.querySelector('.form__message');
        
        if (!errorSpan) {
          errorSpan = document.createElement('span');
          errorSpan.className = 'form__message';
          input.parentNode.appendChild(errorSpan);
        }
        
        const errorImage = document.createElement('img');
        errorImage.src = errorImageInfo; 
        errorImage.alt = 'Error';
        
        const messageText = document.createTextNode(` ${message}`);
        
        errorSpan.innerHTML = '';
        errorSpan.appendChild(errorImage);
        errorSpan.appendChild(messageText);
        
        input.setAttribute('aria-invalid', 'true');
        input.classList.add('input-error'); 
      }
  
    function clearErrorMessages() {
      const errorMessages = document.querySelectorAll('.form__message');
      errorMessages.forEach(function(message) {
        message.innerHTML = '';
      });
      [firstNameInput, lastNameInput, emailInput, passwordInput].forEach(input => {
        input.removeAttribute('aria-invalid');
        input.classList.remove('input-error'); // Remove red border
      });
    }
  
    function clearErrorMessage(input) {
      const errorSpan = input.parentNode.querySelector('.form__message');
      
      errorSpan.innerHTML = '';
      input.removeAttribute('aria-invalid');
      input.classList.remove('input-error'); // Remove red border
    }
  
    function validateEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(email);
    }
  });
  
  document.addEventListener('DOMContentLoaded', function() {
    const passwordInput = document.getElementById('RegisterForm-password');
    const showPassword = document.getElementById('show-password-create-account');
    const hidePassword = document.getElementById('hide-password-create-account');
    if (hidePassword) {
      hidePassword.addEventListener('click', function() {
        passwordInput.type = 'text';  
        hidePassword.style.display = 'none'; 
        showPassword.style.display = 'inline';
      });
    }
    if ( showPassword ) {
      showPassword.addEventListener('click', function() {
        passwordInput.type = 'password';  
        showPassword.style.display = 'none'; 
        hidePassword.style.display = 'inline'; 
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    const emailInput = document.getElementById('CustomerEmail');
    const passwordInput = document.getElementById('CustomerPassword');
  
    emailInput.addEventListener('input', function() {
      clearErrorMessage(emailInput);
    });

    passwordInput.addEventListener('input', function() {
        clearErrorMessage(passwordInput);
      });
  
    function clearErrorMessage(input) {
      input.classList.remove('error-border'); 
      input.classList.add('no-error-border'); 
      input.removeAttribute('aria-invalid');
    }
  });